import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    fromWallet: {
        id: 'modal.topUp.balances.from_wallet',
        defaultMessage: 'From wallet',
    },
    topUpFee: {
        id: 'modal.topUp.balances.top_up_fee',
        defaultMessage: 'Top up fee',
    },
    toCard: {
        id: 'modal.topUp.balances.to_card',
        defaultMessage: 'To card',
    },
    min: {
        id: 'modal.topUp.balances.min',
        defaultMessage: 'min',
    },
    max: {
        id: 'modal.topUp.balances.max',
        defaultMessage: 'max',
    },
})
